export const ErrorMessage = ({ error }: { error?: string }) => {
  if (!error) return null;
  return <small className="w-100 block text-xs italic text-red-500">{error}</small>;
};
